var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/utility/Providers/index.tsx";
import React from 'react';
import { ParallaxProvider, config } from '@adc/parallax-component-library';
import i18next from 'i18next';
import { useTheme } from 'Hooks';
import { store } from 'Utilities/store';
const Providers = ({
  children
}) => {
  const {
    theme
  } = useTheme();
  const {
    env: {
      isTestEnvironment
    },
    lang: {
      language
    }
  } = store.getState();
  const dir = i18next.dir(language);
  return /*#__PURE__*/React.createElement(ParallaxProvider, {
    config: config,
    locale: language,
    dir: dir,
    isTestEnvironment: Boolean(isTestEnvironment),
    defaultTheme: theme,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 5
    }
  }, children);
};
export default Providers;